import { useSelector } from 'react-redux';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { numberObjectKeys } from '~/_shared/utils/object/objectEnumerators';
import type { AppState } from '~/store/app.store';
import {
  type BoundaryGroupId, type BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import { activeBTGIdPerDataLayerBoundaryGroupSelector } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.selectors';

export const activeBTGIdPerToolsStateBoundaryGroupSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.boundary.activeBTGIdPerBoundaryGroup;
};

export const activeBTGIdPerBoundaryGroupSelector = createStateSelector([
  activeBTGIdPerToolsStateBoundaryGroupSelector,
  activeBTGIdPerDataLayerBoundaryGroupSelector,
], (
  boundaryToolActiveBTGIds,
  dataLayerActiveBTGIds,
): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  const boundaryGroupIds = new Set<BoundaryGroupId>([
    ...numberObjectKeys(boundaryToolActiveBTGIds),
    ...numberObjectKeys(dataLayerActiveBTGIds),
  ]);

  return Array.from(boundaryGroupIds).reduce((acc, id) => {
    if (boundaryToolActiveBTGIds[id]) {
      acc[id] = boundaryToolActiveBTGIds[id];
    }
    else if (dataLayerActiveBTGIds[id]) {
      acc[id] = dataLayerActiveBTGIds[id];
    }
    return acc;
  }, {} as Record<BoundaryGroupId, BoundaryTerritoryGroupId>);
});

export const useActiveBTGIdPerBoundaryGroup = (boundaryGroupId: BoundaryGroupId) => {
  return useSelector(activeBTGIdPerBoundaryGroupSelector)[boundaryGroupId] ?? null;
};
